var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-chart",class:{ 'grow-chart': _vm.grow_chart }},[(_vm.title)?_c('div',{staticClass:"font-weight-bold text-h6 mb-4",class:{
            'text-left': _vm.title_alignment === 'left',
            'text-center': _vm.title_alignment === 'center',
            'text-right': _vm.title_alignment === 'right'
        }},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('line-chart-generator',{staticClass:"line-chart-generator",staticStyle:{"height":"350px"},attrs:{"chartOptions":_vm.chart_options,"chartData":_vm.chart_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }